import React, {useEffect, useState} from 'react';

import PropTypes from "prop-types";
import RetailerIdAndName from "../../Components/RetailerIdAndName";
import {getRetailerName} from "../../../utils/localCache/retailerMapCache";
import {makeApolloClientCall} from "../../../Api/makeApolloApiCall";
import ReactTable from "../../Components/ReactTable";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import Page from "../../Components/Page";
import {Breadcrumbs} from "../../Components/Breadcrumbs";


export const columns = [
    {
        id: 1,
        header: 'Retailer',
        accessorKey: 'retailerId',
        className: 'non-numeric-field sticky-column',
        sticky: 'left',
        filterable: true,
        cell: ({row}) => <RetailerIdAndName retailerId={row.original.retailerId}/>,
        filterFn: (row, columnIds, filterValue) => !filterValue || Boolean(`${row.original.retailerId} ${getRetailerName(row.original.retailerId)?.toLowerCase()}`.includes(filterValue.toLowerCase()))

    },
    {
        id: 2,
        header: 'Store ID',
        filterable: true,
        accessorKey: 'storeId',
        className: 'sticky-column',
        sticky: 'left',
        filterFn: (row, columnIds, filterValue) => !filterValue || Boolean(`${row.original.storeId}`.startsWith(filterValue))
    },

];

function ContinuityTable({query, dataColumns, pageName}) {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const customColumns = [...columns, ...dataColumns]

    useEffect(() => {
        setLoading(true);
        makeApolloClientCall(query)
            .then(data => {
                setError(false);
                setData(data?.data);
            })
            .catch(() => setError(true))
            .finally(() => setLoading(false));
    }, []);

    return <Page name={pageName}
                  breadCrumbs={<Breadcrumbs items={[{label: "Alerts"}, {label: pageName}]}/>}
            >
                <LoadingWrapper loading={loading}>
                    {!error && <ReactTable filterable={true}
                                           columns={customColumns}
                                           data={data}
                                           initialState={{pagination: {pageSize: 50}}}/>}
                    {error && <div className={'error-message'} data-testid={'error-div'}>Error loading data</div>}
                </LoadingWrapper>
            </Page>
}

ContinuityTable.propTypes = {
    pageName: PropTypes.string.isRequired,
    query: PropTypes.string.isRequired,
    dataColumns: PropTypes.arrayOf(PropTypes.object)
}

export default ContinuityTable;
